/**
 * Returns if chaper's goal has been met by implementation
 */
let test = (node) => {
    // TODO: Implement
    return node != null;
};

export default test;
